<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">

				<el-form-item label="提现状态" label-width='70px'>
					<el-select clearable v-model="secah.withdrawalStatus" placeholder="请选择提现状态">
						<el-option label="审核中" :value="1"></el-option>
						<el-option label="已通过" :value="2"></el-option>
						<el-option label="审核不通过" :value="3"></el-option>

					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button @click='secahClick'>搜索</el-button>
				</el-form-item>

			</el-form>
		</el-col>

		<div>
			<el-table :data="tableData" style="width: 100%" border>
				<el-table-column prop="fullName" label="申请人姓名" align="center">
				</el-table-column>
				<el-table-column prop="alipayName" label="支付宝姓名" align="center">
				</el-table-column>
				<el-table-column prop="alipayAccount" label="支付宝登录账号" align="center">
				</el-table-column>
				<el-table-column prop="amount" label="提现金额" align="center">
				</el-table-column>
				<el-table-column prop="tel" label="申请人手机号" align="center">
				</el-table-column>
				<el-table-column prop="withdrawalStatus" label="提现状态" align="center">
					<template slot-scope="scope">
						{{scope.row.withdrawalStatus==1?"审核中":scope.row.withdrawalStatus==2?"已通过":"审核不通过"}}
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="220" align="center">
					<template slot-scope="scope">
						<el-button type="success" v-if="scope.row.withdrawalStatus==1"  size="mini" @click="agreeWithdrawal(scope.row)">申请通过</el-button>
						<el-button type="danger" v-if="scope.row.withdrawalStatus==1"  size="mini" @click="refuseWithdrawal(scope.row)">拒绝申请</el-button>	
						<!-- <el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
						<el-button size="mini" type="warning" @click="reset(scope.row)">重置密码</el-button> -->
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="拒绝原因" :visible.sync="isreason" :modal-append-to-body='false' width="600px">
				<el-form>
					
					<el-form-item label="拒绝原因" label-width='80px'>
						<el-input type="textarea" v-model="refuseReason" maxlength="10" autocomplete="off" placeholder="请输入拒绝原因"></el-input>
					</el-form-item>
					
				
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="isreason = false">取 消</el-button>
					<el-button type="primary" @click="sub">确 定</el-button>
				</div>
			</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				total: 0,
				isreason:false,
				refuseReason:"",
				secah: {
					pageSize: 10,
					pageNum: 1,
					withdrawalStatus: ""
				},
				withdrawalId:""


			}
		},
		created() {
			this.getList()
		},
		methods: {
			//搜索
			secahClick() {
				this.secah.pageNum = 1
				this.getList()
			},

			//通过
			agreeWithdrawal(row){
				this.$confirm('确定通过当前提现申请?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpPost('/withdrawal/agreeWithdrawal?withdrawalId='+row.withdrawalId).then(res => {
						if (res.code == 200) {
							this.$message.success('操作成功');
							this.dialogVisible = false
							this.getList()
							// this.getUserList()
						}
					})
				}).catch(() => {});
			},
			//拒绝通过
			refuseWithdrawal(row){
				this.isreason=true
				this.withdrawalId=row.withdrawalId		
			},
			//确定拒绝通过
			sub(){
				this.httpPost('/withdrawal/refuseWithdrawal?withdrawalId='+this.withdrawalId+"&refuseReason="+this.refuseReason).then(res => {
					if (res.code == 200) {
						this.$message.success('操作成功');
						this.isreason = false
						this.getList()
						// this.getUserList()
					}
				})
			},


			//选择分页条数
			handleSizeChange(e) {
				this.secah.pageNum = 1
				this.secah.pageSize = e
				this.getList()
			},
			//页码
			handleCurrentChange(e) {
				this.secah.pageNum = e
				this.getList()
			},
			//获取数据
			getList() {
				var secah=this.secah
				// secah.withdrawalStatus=secah.withdrawalStatus?secah.withdrawalStatus:0
				this.httpPost("/withdrawal/withdrawalByPage", secah, true, {
					'Content-Type': 'application/json'
				}).then(res => {
					if (res.code == 200) {
						this.tableData = res.data.content
						this.total = res.data.total
					}
				})

			},


		},


	}
</script>

<style scoped lang='scss'>
	.page {
		padding: 20px 0;
	}
</style>
